'use client';

import { useLocaleStore } from '@/client/stores/useLocaleStore';
import { cn } from '@/utils';
import { ClassValue } from 'clsx';
import Link from 'next/link';

interface Props {
  className?: ClassValue;
}

export function TermsOfServiceLink({ className }: Props) {
  const { locale } = useLocaleStore();
  const text = locale === 'en' ? 'Terms of Service' : '서비스 약관';
  const font = locale === 'en' ? 'font-mono' : 'font-sans';

  return (
    <Link href={'/terms-of-service'}>
      <span className={cn(`flex h-full items-center justify-center ${font}`, className)}>{text}</span>
    </Link>
  );
}
